import React, { useState, useEffect } from "react";
import Layout from "app/components/layouts";
import success from "app/assets/images/success.svg";
import successGif from "app/assets/images/success.gif";
import { RootState } from "app/lib/store/store";
import { useSelector } from "react-redux";

const Success: React.FC = () => {
  const { applicationReferenceNumber } = useSelector(
    (state: RootState) => state.loanTypesSteps?.savedIds
  );

  const [showSuccessSVG, setShowSuccessSVG] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSuccessSVG(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const clearStorageTimer = setTimeout(() => {
      localStorage.clear();
    }, 5000);

    return () => clearTimeout(clearStorageTimer);
  }, []);
  return (
    <>
      <Layout>
        <div className="w-[90%] sm:w-[40%] mx-auto text-center  sm:px-2 mt-8">
          <h1 className="font-Poppins text-[24px] sm:text-[40px] text-primary font-bold mb-4">
            Success !!!
          </h1>
          <div className="text-center mt-4">
            <img
              src={showSuccessSVG ? success : successGif}
              alt="success"
              className="text-center mx-auto"
            />
            <p className="font-Mulish text-[16px] text-[#585C7B] mt-5">
              Your loan application against{" "}
              <span className="text-[#D1A960]">Referece ID</span>{" "}
              <span className="text-[#D1A960]">
                {applicationReferenceNumber ? applicationReferenceNumber : ""}
              </span>{" "}
              has been successfully submitted. We will get back to you in 1
              working day.
            </p>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Success;
